import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import { Subject } from 'rxjs';
import * as i2 from 'base-education-details-library';
import { BaseEducationDetailsLibraryService } from 'base-education-details-library';
import { first } from 'rxjs/operators';
import * as i1 from '@ngrx/store';
import * as i3 from 'ngx-toastr';
import * as i4 from 'step-status-update-payload-service';
import * as i5 from 'primeng/dynamicdialog';
import * as i6 from '@angular/router';
import * as i7 from 'app-services-library';
import * as i8 from 'dirty-check-store';
import * as i9 from 'reference-library';
import * as i10 from '@angular/common';
import * as i11 from 'step-status-update-component-library';
import { StepStatusUpdateComponentLibraryModule } from 'step-status-update-component-library';
import * as i12 from 'maximize-dialog-library';
import { MaximizeDialogLibraryModule } from 'maximize-dialog-library';
import * as i13 from 'assigning-task-library';
import { AssigningTaskLibraryModule } from 'assigning-task-library';
import * as i14 from 'primeng/divider';
import * as i15 from 'last-update-library';
import { LastUpdateLibraryModule } from 'last-update-library';
import * as i16 from 'primeng/button';
import * as i17 from 'primeng/tooltip';
import * as i18 from '@angular/material/icon';
import * as i19 from 'generic-beneficiary-education';
import { GenericBeneficiaryEducationModule } from 'generic-beneficiary-education';
import * as i20 from 'editor-library';
import { EditorLibraryModule } from 'editor-library';
import * as i21 from 'primeng/table';
import * as i22 from 'primeng/api';
import * as i23 from 'primeng/card';
import * as i24 from 'send-back-component-library';
import { SendBackComponentLibraryModule } from 'send-back-component-library';
import * as i25 from 'notification-component-library';
import { NotificationComponentLibraryModule } from 'notification-component-library';
import * as i26 from 'custom-questionnaire';
import { CustomQuestionnaireModule } from 'custom-questionnaire';
import * as i27 from 'date-format';
import { DateFormatModule } from 'date-format';
import { DeleteDialogLibraryModule } from 'delete-dialog-library';
import { PrimengLibraryModule } from 'primeng-library';
import { ImportProfileDetailsModule } from 'import-profile-details';
import { EditEducationDetailsTabModule } from 'edit-education-details-tab';
import { MatButtonToggleModule } from '@angular/material/button-toggle';

class EducationDetailsLibraryService {
    constructor() { }
}
EducationDetailsLibraryService.ɵfac = function EducationDetailsLibraryService_Factory(t) { return new (t || EducationDetailsLibraryService)(); };
EducationDetailsLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: EducationDetailsLibraryService, factory: EducationDetailsLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EducationDetailsLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

function EducationDetailsLibraryComponent_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵelementStart(1, "div", 12);
    i0.ɵɵelementStart(2, "h5", 13);
    i0.ɵɵtext(3, "Educational Details");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function EducationDetailsLibraryComponent_div_1_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵelement(1, "lib-step-status-update-component-library", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("visaType", ctx_r11.inputData.caseType != "I130" ? ctx_r11.inputData.visatype : ctx_r11.inputData.caseType)("stepDetails", ctx_r11.stepDetails);
} }
const _c0 = function (a0) { return { "layoutCode": a0 }; };
function EducationDetailsLibraryComponent_div_1_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵelement(1, "lib-maximize-dialog-library", 17);
    i0.ɵɵelementStart(2, "i", 18);
    i0.ɵɵlistener("click", function EducationDetailsLibraryComponent_div_1_div_3_Template_i_click_2_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(2); return ctx_r13.handleClose(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("configData", i0.ɵɵpureFunction1(1, _c0, ctx_r12.inputData == null ? null : ctx_r12.inputData.layoutCode));
} }
function EducationDetailsLibraryComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtemplate(1, EducationDetailsLibraryComponent_div_1_div_1_Template, 4, 0, "div", 8);
    i0.ɵɵtemplate(2, EducationDetailsLibraryComponent_div_1_div_2_Template, 2, 2, "div", 9);
    i0.ɵɵtemplate(3, EducationDetailsLibraryComponent_div_1_div_3_Template, 3, 3, "div", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.isWizard);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.isWizard);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.isWizard);
} }
function EducationDetailsLibraryComponent_div_2_lib_assigning_task_library_2_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "lib-assigning-task-library", 22);
    i0.ɵɵlistener("updateStatus", function EducationDetailsLibraryComponent_div_2_lib_assigning_task_library_2_Template_lib_assigning_task_library_updateStatus_0_listener($event) { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(2); return ctx_r16.updateStepStatus($event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("visaType", ctx_r15.inputData.visatype)("stepDetails", ctx_r15.stepDetails)("isViewMode", ctx_r15.inputData["isViewMode"])("isCaseRequest", ctx_r15.inputData["isCaseRequest"]);
} }
function EducationDetailsLibraryComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵelementStart(1, "div", 20);
    i0.ɵɵtemplate(2, EducationDetailsLibraryComponent_div_2_lib_assigning_task_library_2_Template, 1, 4, "lib-assigning-task-library", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r1.isWizard);
} }
function EducationDetailsLibraryComponent_ng_container_3_p_divider_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p-divider", 24);
} }
function EducationDetailsLibraryComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EducationDetailsLibraryComponent_ng_container_3_p_divider_1_Template, 1, 0, "p-divider", 23);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.isSimplifyH1b ? false : true);
} }
function EducationDetailsLibraryComponent_ng_container_5_lib_last_update_library_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "lib-last-update-library", 26);
} if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("inputDetails", ctx_r19.stepDetails)("primaryData", ctx_r19.inputData);
} }
function EducationDetailsLibraryComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, EducationDetailsLibraryComponent_ng_container_5_lib_last_update_library_1_Template, 1, 2, "lib-last-update-library", 25);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.isSimplifyH1b ? false : true);
} }
function EducationDetailsLibraryComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵelementStart(1, "button", 28);
    i0.ɵɵlistener("click", function EducationDetailsLibraryComponent_div_6_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r21); const ctx_r20 = i0.ɵɵnextContext(); return ctx_r20.sycProfilePitition(); });
    i0.ɵɵtext(2, "SYNC");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 29);
    i0.ɵɵlistener("click", function EducationDetailsLibraryComponent_div_6_Template_button_click_3_listener() { i0.ɵɵrestoreView(_r21); const ctx_r22 = i0.ɵɵnextContext(); return ctx_r22.syncEduMerge(); });
    i0.ɵɵtext(4, "MERGE");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "button", 30);
    i0.ɵɵlistener("click", function EducationDetailsLibraryComponent_div_6_Template_button_click_5_listener() { i0.ɵɵrestoreView(_r21); const ctx_r23 = i0.ɵɵnextContext(); return ctx_r23.syncEduReset(); });
    i0.ɵɵtext(6, "RESET");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "button", 31);
    i0.ɵɵlistener("click", function EducationDetailsLibraryComponent_div_6_Template_button_click_7_listener() { i0.ɵɵrestoreView(_r21); const ctx_r24 = i0.ɵɵnextContext(); return ctx_r24.onClickEditImmigation(); });
    i0.ɵɵelementStart(8, "mat-icon", 32);
    i0.ɵɵtext(9, "edit");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(10, "Edit");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r4.disabledControls);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r4.disabledControls);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r4.disabledControls);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r4.disabledControls);
} }
function EducationDetailsLibraryComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵelement(1, "lib-generic-beneficiary-education", 34);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("isSyncPage", true)("isUsedForBeneEdit", false)("inputData", ctx_r5.primaryData)("isWizard", true);
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_1_th_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 57);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r40 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", col_r40.header, " ");
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 54);
    i0.ɵɵelement(1, "th", 55);
    i0.ɵɵtemplate(2, EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_1_th_2_Template, 2, 1, "th", 56);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const columns_r38 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", columns_r38);
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_2_td_3_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const rowData_r41 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", rowData_r41["degreeType"] ? rowData_r41["degreeType"]["name"] : rowData_r41["degreeType"], " ");
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_2_td_3_span_4_Template(rf, ctx) { if (rf & 1) {
    const _r51 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 64);
    i0.ɵɵelementStart(1, "button", 65);
    i0.ɵɵlistener("click", function EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_2_td_3_span_4_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r51); const rowData_r41 = i0.ɵɵnextContext(2).$implicit; const ctx_r49 = i0.ɵɵnextContext(3); return ctx_r49.deleteEducationList(rowData_r41); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "button", 66);
    i0.ɵɵlistener("click", function EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_2_td_3_span_4_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r51); const rowData_r41 = i0.ɵɵnextContext(2).$implicit; const ctx_r52 = i0.ɵɵnextContext(3); return ctx_r52.syncSingleEduaction(rowData_r41); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r47 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r47.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r47.disabledControls);
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_2_td_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 62);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_2_td_3_span_3_Template, 2, 1, "span", 3);
    i0.ɵɵtemplate(4, EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_2_td_3_span_4_Template, 3, 2, "span", 63);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r45 = ctx.$implicit;
    const rowData_r41 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", rowData_r41[col_r45.field], " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", col_r45.field === "degree");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", col_r45.field === "action");
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 58);
    i0.ɵɵelementStart(1, "td", 59);
    i0.ɵɵelement(2, "button", 60);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_2_td_3_Template, 5, 3, "td", 61);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const rowData_r41 = ctx.$implicit;
    const expanded_r42 = ctx.expanded;
    const columns_r43 = ctx.columns;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("pRowToggler", rowData_r41)("icon", expanded_r42 ? "pi pi-chevron-down" : "pi pi-chevron-right");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", columns_r43);
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_3_ng_template_4_th_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r63 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", col_r63.header, " ");
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_3_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵtemplate(1, EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_3_ng_template_4_th_1_Template, 2, 1, "th", 72);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const columns_r61 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", columns_r61);
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_3_ng_template_5_td_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const rowData_r64 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", rowData_r64["country"] && rowData_r64["country"]["countryName"] ? rowData_r64["country"]["countryName"] : "", " ");
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_3_ng_template_5_td_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td");
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_3_ng_template_5_td_1_span_3_Template, 2, 1, "span", 3);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r67 = ctx.$implicit;
    const rowData_r64 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", rowData_r64[col_r67.field], " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", col_r67.field === "countryCode");
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_3_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵtemplate(1, EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_3_ng_template_5_td_1_Template, 4, 2, "td", 72);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const columns_r65 = ctx.columns;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", columns_r65);
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_3_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td", 73);
    i0.ɵɵtext(2, "No Data");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_3_div_7_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r76 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 77);
    i0.ɵɵelementStart(1, "div", 78);
    i0.ɵɵelementStart(2, "span", 79);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4, "\u00A0\u00A0 ");
    i0.ɵɵelementStart(5, "b", 80);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 81);
    i0.ɵɵelementStart(8, "button", 82);
    i0.ɵɵlistener("click", function EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_3_div_7_div_4_Template_button_click_8_listener() { i0.ɵɵrestoreView(_r76); const item_r72 = ctx.$implicit; const subeducationlist_r55 = i0.ɵɵnextContext(2).$implicit; const ctx_r74 = i0.ɵɵnextContext(3); return ctx_r74.deleteCoursesList(subeducationlist_r55, item_r72); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r72 = ctx.$implicit;
    const i_r73 = ctx.index;
    const ctx_r71 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i_r73 + 1);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(item_r72.courseName);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r71.disabledControls);
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_3_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 74);
    i0.ɵɵelementStart(1, "h6");
    i0.ɵɵtext(2, "List of Courses");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p-card", 75);
    i0.ɵɵtemplate(4, EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_3_div_7_div_4_Template, 9, 3, "div", 76);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const subeducationlist_r55 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", subeducationlist_r55.courses);
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_3_div_8_div_14_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 90);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r79 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", item_r79.fileName, " ");
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_3_div_8_div_14_span_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 91);
    i0.ɵɵelement(1, "i", 92);
    i0.ɵɵtext(2, " Document Missing ");
    i0.ɵɵelementEnd();
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_3_div_8_div_14_div_10_lib_send_back_component_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "lib-send-back-component", 96);
} if (rf & 2) {
    const item_r79 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r86 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("disabledControls", ctx_r86.disabledControls)("stepDetails", ctx_r86.stepDetails)("primaryData", ctx_r86.primaryData)("item", item_r79);
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_3_div_8_div_14_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r90 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 93);
    i0.ɵɵelementStart(1, "button", 94);
    i0.ɵɵlistener("click", function EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_3_div_8_div_14_div_10_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r90); const item_r79 = i0.ɵɵnextContext().$implicit; const ctx_r88 = i0.ɵɵnextContext(5); return ctx_r88.openDoc(item_r79); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_3_div_8_div_14_div_10_lib_send_back_component_2_Template, 1, 4, "lib-send-back-component", 95);
    i0.ɵɵelementStart(3, "button", 82);
    i0.ɵɵlistener("click", function EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_3_div_8_div_14_div_10_Template_button_click_3_listener() { i0.ɵɵrestoreView(_r90); const item_r79 = i0.ɵɵnextContext().$implicit; const subeducationlist_r55 = i0.ɵɵnextContext(2).$implicit; const ctx_r91 = i0.ɵɵnextContext(3); return ctx_r91.deleteDocumentsList(subeducationlist_r55, item_r79); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r79 = i0.ɵɵnextContext().$implicit;
    const ctx_r83 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", !item_r79.fileLocation);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r83.userType !== "Beneficiary");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r83.disabledControls);
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_3_div_8_div_14_div_11_notification_component_library_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "notification-component-library", 99);
} if (rf & 2) {
    const item_r79 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r95 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("disabledControls", ctx_r95.disabledControls)("stepDetails", ctx_r95.stepDetails)("destination", ctx_r95.notifyDestinationUser)("primaryData", ctx_r95.primaryData)("item", item_r79);
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_3_div_8_div_14_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 97);
    i0.ɵɵtemplate(1, EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_3_div_8_div_14_div_11_notification_component_library_1_Template, 1, 5, "notification-component-library", 98);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r84 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r84.userType !== "Beneficiary");
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_3_div_8_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 77);
    i0.ɵɵelementStart(1, "div", 84);
    i0.ɵɵelementStart(2, "span", 79);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4, " \u00A0\u00A0 ");
    i0.ɵɵelementStart(5, "b", 80);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 84);
    i0.ɵɵtemplate(8, EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_3_div_8_div_14_span_8_Template, 2, 1, "span", 86);
    i0.ɵɵtemplate(9, EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_3_div_8_div_14_span_9_Template, 3, 0, "span", 87);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(10, EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_3_div_8_div_14_div_10_Template, 4, 3, "div", 88);
    i0.ɵɵtemplate(11, EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_3_div_8_div_14_div_11_Template, 2, 1, "div", 89);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r79 = ctx.$implicit;
    const i_r80 = ctx.index;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i_r80 + 1);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", (item_r79 == null ? null : item_r79.fileCategory.code) === "OTHER" && item_r79.isPresent ? item_r79.fileCategoryOtherName : item_r79 == null ? null : item_r79.fileCategory.name, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", item_r79.isPresent);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !item_r79.isPresent);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r79 == null ? null : item_r79.isPresent);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !(item_r79 == null ? null : item_r79.isPresent));
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_3_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 74);
    i0.ɵɵelementStart(1, "h6");
    i0.ɵɵtext(2, "List of Documents");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p-card", 75);
    i0.ɵɵelementStart(4, "div", 83);
    i0.ɵɵelementStart(5, "div", 84);
    i0.ɵɵelementStart(6, "h6");
    i0.ɵɵtext(7, "Document Type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 84);
    i0.ɵɵelementStart(9, "h6");
    i0.ɵɵtext(10, "Document Name ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 85);
    i0.ɵɵelementStart(12, "h6");
    i0.ɵɵtext(13, "Action");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(14, EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_3_div_8_div_14_Template, 12, 6, "div", 76);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const subeducationlist_r55 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(14);
    i0.ɵɵproperty("ngForOf", subeducationlist_r55.documents);
} }
const _c1 = function (a0) { return [a0]; };
function EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td", 67);
    i0.ɵɵelementStart(2, "div", 68);
    i0.ɵɵelementStart(3, "p-table", 69);
    i0.ɵɵtemplate(4, EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_3_ng_template_4_Template, 2, 1, "ng-template", 51);
    i0.ɵɵtemplate(5, EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_3_ng_template_5_Template, 2, 1, "ng-template", 52);
    i0.ɵɵtemplate(6, EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_3_ng_template_6_Template, 3, 0, "ng-template", 70);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_3_div_7_Template, 5, 1, "div", 71);
    i0.ɵɵtemplate(8, EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_3_div_8_Template, 15, 1, "div", 71);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const subeducationlist_r55 = ctx.$implicit;
    const ctx_r37 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("columns", ctx_r37.educationSubCols)("value", i0.ɵɵpureFunction1(4, _c1, subeducationlist_r55));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", subeducationlist_r55.courses && subeducationlist_r55.courses.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", subeducationlist_r55.documents && subeducationlist_r55.documents.length > 0);
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p-table", 50);
    i0.ɵɵtemplate(1, EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_1_Template, 3, 1, "ng-template", 51);
    i0.ɵɵtemplate(2, EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_2_Template, 4, 3, "ng-template", 52);
    i0.ɵɵtemplate(3, EducationDetailsLibraryComponent_ng_container_8_p_table_6_ng_template_3_Template, 9, 6, "ng-template", 53);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r25 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("columns", ctx_r25.educationCols)("value", ctx_r25.educationList);
} }
function EducationDetailsLibraryComponent_ng_container_8_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 100);
    i0.ɵɵtext(1, "Education details need to be filled under individual/beneficiary profile before syncing it here.");
    i0.ɵɵelementEnd();
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_19_ng_template_1_th_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r103 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", col_r103.header, " ");
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_19_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 54);
    i0.ɵɵelement(1, "th", 102);
    i0.ɵɵtemplate(2, EducationDetailsLibraryComponent_ng_container_8_p_table_19_ng_template_1_th_2_Template, 2, 1, "th", 72);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const columns_r101 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", columns_r101);
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_19_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r108 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td", 103);
    i0.ɵɵelement(2, "button", 60);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td", 104);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "td");
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "VisaDateFormat");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "td");
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "VisaDateFormat");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "td", 64);
    i0.ɵɵelementStart(16, "button", 105);
    i0.ɵɵlistener("click", function EducationDetailsLibraryComponent_ng_container_8_p_table_19_ng_template_2_Template_button_click_16_listener() { i0.ɵɵrestoreView(_r108); const rowData_r104 = ctx.$implicit; const ctx_r107 = i0.ɵɵnextContext(3); return ctx_r107.deleteTrainingList(rowData_r104); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "button", 106);
    i0.ɵɵlistener("click", function EducationDetailsLibraryComponent_ng_container_8_p_table_19_ng_template_2_Template_button_click_17_listener() { i0.ɵɵrestoreView(_r108); const rowData_r104 = ctx.$implicit; const ctx_r109 = i0.ɵɵnextContext(3); return ctx_r109.handleTrainingSync(rowData_r104); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const rowData_r104 = ctx.$implicit;
    const expanded_r105 = ctx.expanded;
    const ctx_r99 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("pRowToggler", rowData_r104)("icon", expanded_r105 ? "pi pi-chevron-down" : "pi pi-chevron-right");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", rowData_r104["name"], " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", rowData_r104["subjects"], " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", rowData_r104["institution"], " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(11, 9, rowData_r104["startDate"]), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(14, 11, rowData_r104["endDate"]), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("disabled", ctx_r99.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r99.disabledControls);
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_19_ng_template_3_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 109);
    i0.ɵɵelementStart(1, "h6");
    i0.ɵɵtext(2, "Topic of Study");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p-card", 75);
    i0.ɵɵelementStart(4, "div", 77);
    i0.ɵɵelementStart(5, "div", 110);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const subeducationlist_r110 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", subeducationlist_r110.subjects, " ");
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_19_ng_template_3_div_4_div_14_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r115 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", item_r115.fileName, " ");
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_19_ng_template_3_div_4_div_14_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 91);
    i0.ɵɵelement(1, "i", 92);
    i0.ɵɵtext(2, " Document Missing ");
    i0.ɵɵelementEnd();
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_19_ng_template_3_div_4_div_14_div_9_lib_send_back_component_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "lib-send-back-component", 96);
} if (rf & 2) {
    const item_r115 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r122 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("disabledControls", ctx_r122.disabledControls)("stepDetails", ctx_r122.stepDetails)("primaryData", ctx_r122.primaryData)("item", item_r115);
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_19_ng_template_3_div_4_div_14_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r126 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 93);
    i0.ɵɵelementStart(1, "button", 94);
    i0.ɵɵlistener("click", function EducationDetailsLibraryComponent_ng_container_8_p_table_19_ng_template_3_div_4_div_14_div_9_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r126); const item_r115 = i0.ɵɵnextContext().$implicit; const ctx_r124 = i0.ɵɵnextContext(5); return ctx_r124.openDoc(item_r115); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, EducationDetailsLibraryComponent_ng_container_8_p_table_19_ng_template_3_div_4_div_14_div_9_lib_send_back_component_2_Template, 1, 4, "lib-send-back-component", 95);
    i0.ɵɵelementStart(3, "button", 111);
    i0.ɵɵlistener("click", function EducationDetailsLibraryComponent_ng_container_8_p_table_19_ng_template_3_div_4_div_14_div_9_Template_button_click_3_listener() { i0.ɵɵrestoreView(_r126); const item_r115 = i0.ɵɵnextContext().$implicit; const subeducationlist_r110 = i0.ɵɵnextContext(2).$implicit; const ctx_r127 = i0.ɵɵnextContext(3); return ctx_r127.deleteTrainingDocumentsList(subeducationlist_r110, item_r115); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r115 = i0.ɵɵnextContext().$implicit;
    const ctx_r119 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", !item_r115.fileLocation);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r119.userType !== "Beneficiary");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r119.disabledControls);
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_19_ng_template_3_div_4_div_14_div_10_notification_component_library_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "notification-component-library", 99);
} if (rf & 2) {
    const item_r115 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r131 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("disabledControls", ctx_r131.disabledControls)("stepDetails", ctx_r131.stepDetails)("destination", ctx_r131.notifyDestinationUser)("primaryData", ctx_r131.primaryData)("item", item_r115);
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_19_ng_template_3_div_4_div_14_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 97);
    i0.ɵɵtemplate(1, EducationDetailsLibraryComponent_ng_container_8_p_table_19_ng_template_3_div_4_div_14_div_10_notification_component_library_1_Template, 1, 5, "notification-component-library", 98);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r120 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r120.userType !== "Beneficiary");
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_19_ng_template_3_div_4_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 77);
    i0.ɵɵelementStart(1, "div", 84);
    i0.ɵɵelementStart(2, "span", 79);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 84);
    i0.ɵɵtemplate(7, EducationDetailsLibraryComponent_ng_container_8_p_table_19_ng_template_3_div_4_div_14_span_7_Template, 2, 1, "span", 3);
    i0.ɵɵtemplate(8, EducationDetailsLibraryComponent_ng_container_8_p_table_19_ng_template_3_div_4_div_14_span_8_Template, 3, 0, "span", 87);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, EducationDetailsLibraryComponent_ng_container_8_p_table_19_ng_template_3_div_4_div_14_div_9_Template, 4, 3, "div", 88);
    i0.ɵɵtemplate(10, EducationDetailsLibraryComponent_ng_container_8_p_table_19_ng_template_3_div_4_div_14_div_10_Template, 2, 1, "div", 89);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r115 = ctx.$implicit;
    const i_r116 = ctx.index;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i_r116 + 1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", (item_r115 == null ? null : item_r115.fileCategory.code) === "OTHER" && item_r115.isPresent ? item_r115.fileCategoryOtherName : item_r115 == null ? null : item_r115.fileCategory.name, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", item_r115.isPresent);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !item_r115.isPresent);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r115 == null ? null : item_r115.isPresent);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !(item_r115 == null ? null : item_r115.isPresent));
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_19_ng_template_3_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 74);
    i0.ɵɵelementStart(1, "h6");
    i0.ɵɵtext(2, "List of Documents");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p-card", 75);
    i0.ɵɵelementStart(4, "div", 83);
    i0.ɵɵelementStart(5, "div", 84);
    i0.ɵɵelementStart(6, "h6");
    i0.ɵɵtext(7, "Document Type ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 84);
    i0.ɵɵelementStart(9, "h6");
    i0.ɵɵtext(10, "Document Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 85);
    i0.ɵɵelementStart(12, "h6");
    i0.ɵɵtext(13, "Action");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(14, EducationDetailsLibraryComponent_ng_container_8_p_table_19_ng_template_3_div_4_div_14_Template, 11, 6, "div", 76);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const subeducationlist_r110 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(14);
    i0.ɵɵproperty("ngForOf", subeducationlist_r110.documents);
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_19_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td", 107);
    i0.ɵɵelementStart(2, "div", 68);
    i0.ɵɵtemplate(3, EducationDetailsLibraryComponent_ng_container_8_p_table_19_ng_template_3_div_3_Template, 7, 1, "div", 108);
    i0.ɵɵtemplate(4, EducationDetailsLibraryComponent_ng_container_8_p_table_19_ng_template_3_div_4_Template, 15, 1, "div", 71);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const subeducationlist_r110 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", subeducationlist_r110.subjects && subeducationlist_r110.subjects.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", subeducationlist_r110.documents && subeducationlist_r110.documents.length > 0);
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_19_Template(rf, ctx) { if (rf & 1) {
    const _r135 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-table", 101);
    i0.ɵɵlistener("onRowExpand", function EducationDetailsLibraryComponent_ng_container_8_p_table_19_Template_p_table_onRowExpand_0_listener($event) { i0.ɵɵrestoreView(_r135); const ctx_r134 = i0.ɵɵnextContext(2); return ctx_r134.onRowExpand($event); });
    i0.ɵɵtemplate(1, EducationDetailsLibraryComponent_ng_container_8_p_table_19_ng_template_1_Template, 3, 1, "ng-template", 51);
    i0.ɵɵtemplate(2, EducationDetailsLibraryComponent_ng_container_8_p_table_19_ng_template_2_Template, 18, 13, "ng-template", 52);
    i0.ɵɵtemplate(3, EducationDetailsLibraryComponent_ng_container_8_p_table_19_ng_template_3_Template, 5, 2, "ng-template", 53);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r28 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("columns", ctx_r28.trainingCols)("value", ctx_r28.trainingList);
} }
function EducationDetailsLibraryComponent_ng_container_8_ng_template_20_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 112);
    i0.ɵɵtext(1, "Training details need to be filled under individual/beneficiary profile before syncing it here.");
    i0.ɵɵelementEnd();
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_32_ng_template_1_th_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const col_r141 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", col_r141.header, " ");
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_32_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 54);
    i0.ɵɵelement(1, "th", 102);
    i0.ɵɵtemplate(2, EducationDetailsLibraryComponent_ng_container_8_p_table_32_ng_template_1_th_2_Template, 2, 1, "th", 72);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const columns_r139 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", columns_r139);
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_32_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r146 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td", 103);
    i0.ɵɵelement(2, "button", 60);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td", 104);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "td");
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "VisaDateFormat");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "td");
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "VisaDateFormat");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "td", 64);
    i0.ɵɵelementStart(16, "button", 114);
    i0.ɵɵlistener("click", function EducationDetailsLibraryComponent_ng_container_8_p_table_32_ng_template_2_Template_button_click_16_listener() { i0.ɵɵrestoreView(_r146); const rowData_r142 = ctx.$implicit; const ctx_r145 = i0.ɵɵnextContext(3); return ctx_r145.deleteLicensesList(rowData_r142); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "button", 66);
    i0.ɵɵlistener("click", function EducationDetailsLibraryComponent_ng_container_8_p_table_32_ng_template_2_Template_button_click_17_listener() { i0.ɵɵrestoreView(_r146); const rowData_r142 = ctx.$implicit; const ctx_r147 = i0.ɵɵnextContext(3); return ctx_r147.handleLicensesSync(rowData_r142); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const rowData_r142 = ctx.$implicit;
    const expanded_r143 = ctx.expanded;
    const ctx_r137 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("pRowToggler", rowData_r142)("icon", expanded_r143 ? "pi pi-chevron-down" : "pi pi-chevron-right");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", rowData_r142["name"], " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", rowData_r142["subjects"], " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", rowData_r142["institution"], " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(11, 9, rowData_r142["startDate"]), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(14, 11, rowData_r142["endDate"]), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("disabled", ctx_r137.disabledControls);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r137.disabledControls);
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_32_ng_template_3_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 109);
    i0.ɵɵelementStart(1, "h6");
    i0.ɵɵtext(2, "Topic of Study");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p-card", 75);
    i0.ɵɵelementStart(4, "div", 77);
    i0.ɵɵelementStart(5, "div", 110);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const subeducationlist_r148 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", subeducationlist_r148.subjects, " ");
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_32_ng_template_3_div_4_div_14_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r153 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", item_r153.fileName, " ");
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_32_ng_template_3_div_4_div_14_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 91);
    i0.ɵɵelement(1, "i", 92);
    i0.ɵɵtext(2, " Document Missing ");
    i0.ɵɵelementEnd();
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_32_ng_template_3_div_4_div_14_div_9_lib_send_back_component_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "lib-send-back-component", 96);
} if (rf & 2) {
    const item_r153 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r160 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("disabledControls", ctx_r160.disabledControls)("stepDetails", ctx_r160.stepDetails)("primaryData", ctx_r160.primaryData)("item", item_r153);
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_32_ng_template_3_div_4_div_14_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r164 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 93);
    i0.ɵɵelementStart(1, "button", 94);
    i0.ɵɵlistener("click", function EducationDetailsLibraryComponent_ng_container_8_p_table_32_ng_template_3_div_4_div_14_div_9_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r164); const item_r153 = i0.ɵɵnextContext().$implicit; const ctx_r162 = i0.ɵɵnextContext(5); return ctx_r162.openDoc(item_r153); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, EducationDetailsLibraryComponent_ng_container_8_p_table_32_ng_template_3_div_4_div_14_div_9_lib_send_back_component_2_Template, 1, 4, "lib-send-back-component", 95);
    i0.ɵɵelementStart(3, "button", 82);
    i0.ɵɵlistener("click", function EducationDetailsLibraryComponent_ng_container_8_p_table_32_ng_template_3_div_4_div_14_div_9_Template_button_click_3_listener() { i0.ɵɵrestoreView(_r164); const item_r153 = i0.ɵɵnextContext().$implicit; const subeducationlist_r148 = i0.ɵɵnextContext(2).$implicit; const ctx_r165 = i0.ɵɵnextContext(3); return ctx_r165.deleteLicensesDocumentsList(subeducationlist_r148, item_r153); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r153 = i0.ɵɵnextContext().$implicit;
    const ctx_r157 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", !item_r153.fileLocation);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r157.userType !== "Beneficiary");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r157.disabledControls);
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_32_ng_template_3_div_4_div_14_div_10_notification_component_library_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "notification-component-library", 99);
} if (rf & 2) {
    const item_r153 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r169 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("disabledControls", ctx_r169.disabledControls)("stepDetails", ctx_r169.stepDetails)("destination", ctx_r169.notifyDestinationUser)("primaryData", ctx_r169.primaryData)("item", item_r153);
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_32_ng_template_3_div_4_div_14_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 97);
    i0.ɵɵtemplate(1, EducationDetailsLibraryComponent_ng_container_8_p_table_32_ng_template_3_div_4_div_14_div_10_notification_component_library_1_Template, 1, 5, "notification-component-library", 98);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r158 = i0.ɵɵnextContext(6);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r158.userType !== "Beneficiary");
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_32_ng_template_3_div_4_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 77);
    i0.ɵɵelementStart(1, "div", 84);
    i0.ɵɵelementStart(2, "span", 79);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 84);
    i0.ɵɵtemplate(7, EducationDetailsLibraryComponent_ng_container_8_p_table_32_ng_template_3_div_4_div_14_span_7_Template, 2, 1, "span", 3);
    i0.ɵɵtemplate(8, EducationDetailsLibraryComponent_ng_container_8_p_table_32_ng_template_3_div_4_div_14_span_8_Template, 3, 0, "span", 87);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, EducationDetailsLibraryComponent_ng_container_8_p_table_32_ng_template_3_div_4_div_14_div_9_Template, 4, 3, "div", 88);
    i0.ɵɵtemplate(10, EducationDetailsLibraryComponent_ng_container_8_p_table_32_ng_template_3_div_4_div_14_div_10_Template, 2, 1, "div", 89);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r153 = ctx.$implicit;
    const i_r154 = ctx.index;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i_r154 + 1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", (item_r153 == null ? null : item_r153.fileCategory.code) === "OTHER" && item_r153.isPresent ? item_r153.fileCategoryOtherName : item_r153 == null ? null : item_r153.fileCategory.name, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", item_r153.isPresent);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !item_r153.isPresent);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r153 == null ? null : item_r153.isPresent);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !(item_r153 == null ? null : item_r153.isPresent));
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_32_ng_template_3_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 74);
    i0.ɵɵelementStart(1, "h6");
    i0.ɵɵtext(2, "List of Documents");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p-card", 75);
    i0.ɵɵelementStart(4, "div", 83);
    i0.ɵɵelementStart(5, "div", 84);
    i0.ɵɵelementStart(6, "h6");
    i0.ɵɵtext(7, "Document Type");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 84);
    i0.ɵɵelementStart(9, "h6");
    i0.ɵɵtext(10, "Document Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 85);
    i0.ɵɵelementStart(12, "h6");
    i0.ɵɵtext(13, "Action");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(14, EducationDetailsLibraryComponent_ng_container_8_p_table_32_ng_template_3_div_4_div_14_Template, 11, 6, "div", 76);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const subeducationlist_r148 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(14);
    i0.ɵɵproperty("ngForOf", subeducationlist_r148.documents);
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_32_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td", 107);
    i0.ɵɵelementStart(2, "div", 68);
    i0.ɵɵtemplate(3, EducationDetailsLibraryComponent_ng_container_8_p_table_32_ng_template_3_div_3_Template, 7, 1, "div", 108);
    i0.ɵɵtemplate(4, EducationDetailsLibraryComponent_ng_container_8_p_table_32_ng_template_3_div_4_Template, 15, 1, "div", 71);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const subeducationlist_r148 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", subeducationlist_r148.subjects && subeducationlist_r148.subjects.length > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", subeducationlist_r148.documents && subeducationlist_r148.documents.length > 0);
} }
function EducationDetailsLibraryComponent_ng_container_8_p_table_32_Template(rf, ctx) { if (rf & 1) {
    const _r173 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-table", 113);
    i0.ɵɵlistener("onRowExpand", function EducationDetailsLibraryComponent_ng_container_8_p_table_32_Template_p_table_onRowExpand_0_listener($event) { i0.ɵɵrestoreView(_r173); const ctx_r172 = i0.ɵɵnextContext(2); return ctx_r172.onRowExpand($event); });
    i0.ɵɵtemplate(1, EducationDetailsLibraryComponent_ng_container_8_p_table_32_ng_template_1_Template, 3, 1, "ng-template", 51);
    i0.ɵɵtemplate(2, EducationDetailsLibraryComponent_ng_container_8_p_table_32_ng_template_2_Template, 18, 13, "ng-template", 52);
    i0.ɵɵtemplate(3, EducationDetailsLibraryComponent_ng_container_8_p_table_32_ng_template_3_Template, 5, 2, "ng-template", 53);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r31 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("columns", ctx_r31.linceseCols)("value", ctx_r31.licensesList);
} }
function EducationDetailsLibraryComponent_ng_container_8_lib_custom_questionnaire_38_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "lib-custom-questionnaire", 115);
} if (rf & 2) {
    const ctx_r32 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("stepId", ctx_r32.primaryData.stepId)("taskId", ctx_r32.primaryData.taskId)("viewQuestions", false)("showSaveBtn", false)("loadedIn", ctx_r32.stepDetails.stepName)("isSection", false)("isCustomTriggered", ctx_r32.isCustomTriggered);
} }
function EducationDetailsLibraryComponent_ng_container_8_ng_template_39_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 116);
    i0.ɵɵtext(1, "License/certification details need to be filled under individual/beneficiary profile before syncing it here.");
    i0.ɵɵelementEnd();
} }
function EducationDetailsLibraryComponent_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    const _r175 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 35);
    i0.ɵɵelementStart(2, "div", 36);
    i0.ɵɵelementStart(3, "div", 37);
    i0.ɵɵelementStart(4, "h6");
    i0.ɵɵtext(5, "Education Details");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, EducationDetailsLibraryComponent_ng_container_8_p_table_6_Template, 4, 2, "p-table", 38);
    i0.ɵɵtemplate(7, EducationDetailsLibraryComponent_ng_container_8_ng_template_7_Template, 2, 0, "ng-template", null, 39, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 35);
    i0.ɵɵelementStart(10, "div", 36);
    i0.ɵɵelementStart(11, "div", 37);
    i0.ɵɵelementStart(12, "h6");
    i0.ɵɵtext(13, "Training Details");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 40);
    i0.ɵɵelementStart(15, "button", 29);
    i0.ɵɵlistener("click", function EducationDetailsLibraryComponent_ng_container_8_Template_button_click_15_listener() { i0.ɵɵrestoreView(_r175); const ctx_r174 = i0.ɵɵnextContext(); return ctx_r174.syncTraMerge(); });
    i0.ɵɵtext(16, "MERGE");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "button", 30);
    i0.ɵɵlistener("click", function EducationDetailsLibraryComponent_ng_container_8_Template_button_click_17_listener() { i0.ɵɵrestoreView(_r175); const ctx_r176 = i0.ɵɵnextContext(); return ctx_r176.syncTraReset(); });
    i0.ɵɵtext(18, "RESET");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(19, EducationDetailsLibraryComponent_ng_container_8_p_table_19_Template, 4, 2, "p-table", 41);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(20, EducationDetailsLibraryComponent_ng_container_8_ng_template_20_Template, 2, 0, "ng-template", null, 42, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(22, "div", 43);
    i0.ɵɵelementStart(23, "div", 36);
    i0.ɵɵelementStart(24, "div", 37);
    i0.ɵɵelementStart(25, "h6");
    i0.ɵɵtext(26, "Licenses & Certifications Details");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(27, "div", 40);
    i0.ɵɵelementStart(28, "button", 29);
    i0.ɵɵlistener("click", function EducationDetailsLibraryComponent_ng_container_8_Template_button_click_28_listener() { i0.ɵɵrestoreView(_r175); const ctx_r177 = i0.ɵɵnextContext(); return ctx_r177.syncLinMerge(); });
    i0.ɵɵtext(29, "MERGE");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(30, "button", 30);
    i0.ɵɵlistener("click", function EducationDetailsLibraryComponent_ng_container_8_Template_button_click_30_listener() { i0.ɵɵrestoreView(_r175); const ctx_r178 = i0.ɵɵnextContext(); return ctx_r178.syncLinReset(); });
    i0.ɵɵtext(31, "RESET");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(32, EducationDetailsLibraryComponent_ng_container_8_p_table_32_Template, 4, 2, "p-table", 44);
    i0.ɵɵelementStart(33, "div", 45);
    i0.ɵɵelementStart(34, "h6");
    i0.ɵɵtext(35, "Education Summary");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(36, "div", 46);
    i0.ɵɵelementStart(37, "lib-editor-library", 47);
    i0.ɵɵlistener("sendApiStatus", function EducationDetailsLibraryComponent_ng_container_8_Template_lib_editor_library_sendApiStatus_37_listener($event) { i0.ɵɵrestoreView(_r175); const ctx_r179 = i0.ɵɵnextContext(); return ctx_r179.getApiStatus($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(38, EducationDetailsLibraryComponent_ng_container_8_lib_custom_questionnaire_38_Template, 1, 7, "lib-custom-questionnaire", 48);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(39, EducationDetailsLibraryComponent_ng_container_8_ng_template_39_Template, 2, 0, "ng-template", null, 49, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r26 = i0.ɵɵreference(8);
    const _r29 = i0.ɵɵreference(21);
    const _r33 = i0.ɵɵreference(40);
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngIf", ctx_r6.educationList && ctx_r6.educationList.length > 0)("ngIfElse", _r26);
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("disabled", ctx_r6.disabledControls);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r6.disabledControls);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r6.trainingList && ctx_r6.trainingList.length > 0)("ngIfElse", _r29);
    i0.ɵɵadvance(9);
    i0.ɵɵproperty("disabled", ctx_r6.disabledControls);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", ctx_r6.disabledControls);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r6.licensesList && ctx_r6.licensesList.length > 0)("ngIfElse", _r33);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("events", ctx_r6.onSaveEmitSubject.asObservable())("primaryData", ctx_r6.inputData);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r6.isWizard);
} }
function EducationDetailsLibraryComponent_p_divider_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p-divider");
} }
function EducationDetailsLibraryComponent_div_10_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r184 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 119);
    i0.ɵɵelementStart(1, "button", 120);
    i0.ɵɵlistener("click", function EducationDetailsLibraryComponent_div_10_div_1_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r184); const ctx_r183 = i0.ɵɵnextContext(2); return ctx_r183.saveSummaryInfo(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r180 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r180.disabledControls ? "btn-success button-width-icon-left mr-3 btn-success_disabled" : "btn-success button-width-icon-left mr-3")("disabled", ctx_r180.disabledControls);
} }
function EducationDetailsLibraryComponent_div_10_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r186 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 119);
    i0.ɵɵelementStart(1, "button", 121);
    i0.ɵɵlistener("click", function EducationDetailsLibraryComponent_div_10_div_2_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r186); const ctx_r185 = i0.ɵɵnextContext(2); return ctx_r185.saveCloseEditEducation(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r181 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r181.disabledControls ? "btn-success button-width-icon-left mr-3 btn-success_disabled" : "btn-success button-width-icon-left mr-3")("disabled", ctx_r181.disabledControls);
} }
function EducationDetailsLibraryComponent_div_10_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 122);
    i0.ɵɵelement(1, "lib-step-status-update-component-library", 123);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r182 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("visaType", ctx_r182.inputData.caseType != "I130" ? ctx_r182.inputData.visatype : ctx_r182.inputData.caseType)("stepDetails", ctx_r182.stepDetails)("type", ctx_r182.typeOfButton)("showPreviousStepBtn", ctx_r182.showPrev)("showNextStepBtn", ctx_r182.showNext);
} }
function EducationDetailsLibraryComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtemplate(1, EducationDetailsLibraryComponent_div_10_div_1_Template, 2, 2, "div", 117);
    i0.ɵɵtemplate(2, EducationDetailsLibraryComponent_div_10_div_2_Template, 2, 2, "div", 117);
    i0.ɵɵtemplate(3, EducationDetailsLibraryComponent_div_10_div_3_Template, 2, 5, "div", 118);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.isEducationView);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r8.isEducationView);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r8.isWizard);
} }
function EducationDetailsLibraryComponent_div_11_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r190 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 126);
    i0.ɵɵelementStart(1, "button", 127);
    i0.ɵɵlistener("click", function EducationDetailsLibraryComponent_div_11_div_1_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r190); const ctx_r189 = i0.ɵɵnextContext(2); return ctx_r189.saveSummaryInfo(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r187 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r187.disabledControls ? "btn-success button-width-icon-left mr-3 btn-success_disabled" : "btn-success button-width-icon-left mr-3")("disabled", ctx_r187.disabledControls);
} }
function EducationDetailsLibraryComponent_div_11_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r192 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 128);
    i0.ɵɵelementStart(1, "button", 121);
    i0.ɵɵlistener("click", function EducationDetailsLibraryComponent_div_11_div_2_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r192); const ctx_r191 = i0.ɵɵnextContext(2); return ctx_r191.saveCloseEditEducation(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r188 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", ctx_r188.disabledControls ? "btn-success button-width-icon-left mr-3 btn-success_disabled" : "btn-success button-width-icon-left mr-3")("disabled", ctx_r188.disabledControls);
} }
function EducationDetailsLibraryComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵtemplate(1, EducationDetailsLibraryComponent_div_11_div_1_Template, 2, 2, "div", 124);
    i0.ɵɵtemplate(2, EducationDetailsLibraryComponent_div_11_div_2_Template, 2, 2, "div", 125);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r9.isEducationView);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r9.isEducationView);
} }
class EducationDetailsLibraryComponent extends BaseEducationDetailsLibraryService {
    constructor(store, apiService, toastr, stepStatusUpdatePayloadCostructionService, dialogService, router, appServicesLibraryService, guard, referenceLibrary) {
        super(store, apiService, toastr, stepStatusUpdatePayloadCostructionService, dialogService, router, appServicesLibraryService, referenceLibrary);
        this.store = store;
        this.apiService = apiService;
        this.toastr = toastr;
        this.stepStatusUpdatePayloadCostructionService = stepStatusUpdatePayloadCostructionService;
        this.dialogService = dialogService;
        this.router = router;
        this.appServicesLibraryService = appServicesLibraryService;
        this.guard = guard;
        this.referenceLibrary = referenceLibrary;
        this.isWizard = false;
        this.onDialogClose = new EventEmitter();
        this.onSaveEmitSubject = new Subject();
        this.selectedState = 'simple';
        this.getSummaryMessaege$ = new Subject();
        this.formDirtyFromDifferentControls = false;
        this.showNext = false;
        this.showPrev = false;
        this.isCustomTriggered = false;
    }
    ngOnInit() {
        var _a, _b;
        this.isSimplifyH1b = this.simplifyH1b;
        this.inputData = this.primaryData;
        this.showNext = (_a = this.inputData) === null || _a === void 0 ? void 0 : _a.showNext;
        this.showPrev = (_b = this.inputData) === null || _b === void 0 ? void 0 : _b.showPrev;
        super.loadInit();
    }
    onChange($event) {
        this.selectedState = $event.value;
        if (this.selectedState === 'complete') {
            //this.redirectToProfile();
        }
        else if (this.selectedState === 'simple') {
            //this.isEditMode = false;
        }
    }
    handleClose() {
        this.guard.canDeactivate().pipe(first()).subscribe((response) => {
            if (response) {
                this.onDialogClose.emit();
            }
            else {
                return false;
            }
        });
    }
    ngOnDestroy() {
        super.onDestroy();
    }
    getApiStatus(event) {
        super.onGetApiStatus(event);
    }
    saveSummaryInfo() {
        this.onSaveEmitSubject.next();
        super.postFormSubmission();
        this.isCustomTriggered = true;
    }
}
EducationDetailsLibraryComponent.ɵfac = function EducationDetailsLibraryComponent_Factory(t) { return new (t || EducationDetailsLibraryComponent)(i0.ɵɵdirectiveInject(i1.Store), i0.ɵɵdirectiveInject(i2.APIEducationDetails), i0.ɵɵdirectiveInject(i3.ToastrService), i0.ɵɵdirectiveInject(i4.StepStatusUpdatePayloadService), i0.ɵɵdirectiveInject(i5.DialogService), i0.ɵɵdirectiveInject(i6.Router), i0.ɵɵdirectiveInject(i7.AppServicesLibraryService), i0.ɵɵdirectiveInject(i8.DirtyFormGuard), i0.ɵɵdirectiveInject(i9.ReferenceLibraryService)); };
EducationDetailsLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: EducationDetailsLibraryComponent, selectors: [["education-details-library"]], inputs: { primaryData: "primaryData", simplifyH1b: "simplifyH1b", isWizard: "isWizard" }, outputs: { onDialogClose: "onDialogClose" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 12, vars: 11, consts: [[1, "fluid-container"], ["class", "row pt-4 d-flex align-items-center", 4, "ngIf"], ["class", "row", 4, "ngIf"], [4, "ngIf"], [3, "ngClass"], ["class", "btn-group", 4, "ngIf"], ["class", "mb-3", 4, "ngIf"], [1, "row", "pt-4", "d-flex", "align-items-center"], ["class", "col-md-9 step-title p-0", 4, "ngIf"], ["class", "col-md-2 editBtn", 4, "ngIf"], ["class", "col-md-1 pr-0 d-flex justify-content-end", 4, "ngIf"], [1, "col-md-9", "step-title", "p-0"], [1, "w-100", "d-flex"], [1, "mb-0"], [1, "col-md-2", "editBtn"], ["type", "EDIT", 3, "visaType", "stepDetails"], [1, "col-md-1", "pr-0", "d-flex", "justify-content-end"], [3, "configData"], [1, "close-icon", "pi", "pi-times", 3, "click"], [1, "row"], [1, "col-md-12", "p-0"], [3, "visaType", "stepDetails", "isViewMode", "isCaseRequest", "updateStatus", 4, "ngIf"], [3, "visaType", "stepDetails", "isViewMode", "isCaseRequest", "updateStatus"], ["class", "header-divider", 4, "ngIf"], [1, "header-divider"], ["sectionCode", "BEN_EDU", 3, "inputDetails", "primaryData", 4, "ngIf"], ["sectionCode", "BEN_EDU", 3, "inputDetails", "primaryData"], [1, "btn-group"], ["pButton", "", "type", "button", "pTooltip", "Sync With Profile", "icon", "pi pi-arrow-right-arrow-left", 1, "p-button-rounded", "p-button-text", "pull-right", "syncBtn", 3, "disabled", "click"], ["pButton", "", "type", "button", "pTooltip", "Merge Both Profile & Petition Data", "icon", "pi pi-sync\n      ", 1, "p-button-rounded", "p-button-text", "pull-right", "syncBtn", 3, "disabled", "click"], ["pButton", "", "type", "button", "pTooltip", "Reset Petition Data", "icon", "pi pi-undo", 1, "p-button-rounded", "p-button-text", "pull-right", "syncBtn", 3, "disabled", "click"], ["button", "", "pButton", "", "pTooltip", "Edit", 1, "p-button-outlined", "btnData", 3, "disabled", "click"], [1, "mr-1", "icn"], [1, "mb-3"], [3, "isSyncPage", "isUsedForBeneEdit", "inputData", "isWizard"], [1, "row", "pt-3"], [1, "row", "col-md-12", "p-0", "pb-2", "d-flex", "align-items-center", "profile-title"], [1, "col", "p-0", "rowHeader"], ["dataKey", "id", 3, "columns", "value", 4, "ngIf", "ngIfElse"], ["noEducation", ""], [1, "col", "p-0", "btn-group"], ["class", "profile-table pa-table im-card-no-border-table im-card-table-noborder-spacing table", "styleClass", "p-datatable-gridlines", "dataKey", "id", 3, "columns", "value", "onRowExpand", 4, "ngIf", "ngIfElse"], ["noTraining", ""], [1, "row", "pt-3", "pb-0"], ["class", " im-card-no-border-table im-card-table-noborder-spacing table", "styleClass", "p-datatable-gridlines", "dataKey", "id", 3, "columns", "value", "onRowExpand", 4, "ngIf", "ngIfElse"], [1, "row", "col-md-12", "pl-0", "pr-0", "profile-title", "pt-3", "rowHeader"], [1, "col-md-12", "pl-0", "pr-0"], ["infoName", "Education Detail", "infoType", "EDUCEXSUM", 3, "events", "primaryData", "sendApiStatus"], [3, "stepId", "taskId", "viewQuestions", "showSaveBtn", "loadedIn", "isSection", "isCustomTriggered", 4, "ngIf"], ["noLicense", ""], ["dataKey", "id", 3, "columns", "value"], ["pTemplate", "header"], ["pTemplate", "body"], ["pTemplate", "rowexpansion"], [1, "text-uppercase"], [1, "tableHeader", 2, "width", "3rem"], ["class", "tableHeader", 4, "ngFor", "ngForOf"], [1, "tableHeader"], [1, "tableData"], [1, "expandIcon", "eduTable"], ["type", "button", "pButton", "", "pRipple", "", 1, "p-button-text", "p-button-rounded", "p-button-plain", 3, "pRowToggler", "icon"], ["class", "eduTable", 4, "ngFor", "ngForOf"], [1, "eduTable"], ["class", "table-btn", 4, "ngIf"], [1, "table-btn"], ["type", "button", "pButton", "", "icon", "pi pi-trash", "pTooltip", "Delete", 1, "p-button-text", "p-button-rounded", "btnIcon", "btnTrash", 3, "disabled", "click"], ["type", "button", "pButton", "", "icon", "pi pi-refresh", "pTooltip", "Sync", 1, "p-button-text", "p-button-rounded", "refreshIcon", 3, "disabled", "click"], ["colspan", "8"], [1, "p-p-3", "sub-task-type"], ["dataKey", "id", 1, "sub-task-table", "profile-table", 3, "columns", "value"], ["pTemplate", "emptymessage"], ["class", "courseList pt-4", 4, "ngIf"], [4, "ngFor", "ngForOf"], ["colspan", "6"], [1, "courseList", "pt-4"], [1, "courses-card"], ["class", "row courses courses-title d-flex align-items-center", 4, "ngFor", "ngForOf"], [1, "row", "courses", "courses-title", "d-flex", "align-items-center"], [1, "col-md-11"], [1, "duty-list"], [1, "courseName"], [1, "col-md-1", "pull-right"], ["pButton", "", "type", "button", "icon", "pi pi-trash", "pTooltip", "Delete", 1, "p-button-text", "p-button-rounded", 3, "disabled", "click"], [1, "row", "document-header"], [1, "col-md-5"], [1, "col-md-2"], ["class", "docFileName", 4, "ngIf"], ["class", "redColor d-flex align-items-center", 4, "ngIf"], ["class", "col-md-2 pull-right d-flex align-items-center", 4, "ngIf"], ["class", "col-md-2 pull-right", 4, "ngIf"], [1, "docFileName"], [1, "redColor", "d-flex", "align-items-center"], [1, "pi", "pi-exclamation-triangle", "pr-2"], [1, "col-md-2", "pull-right", "d-flex", "align-items-center"], ["pButton", "", "type", "button", "icon", "pi pi-eye", "pTooltip", "View", 1, "p-button-text", "p-button-rounded", 3, "disabled", "click"], [3, "disabledControls", "stepDetails", "primaryData", "item", 4, "ngIf"], [3, "disabledControls", "stepDetails", "primaryData", "item"], [1, "col-md-2", "pull-right"], [3, "disabledControls", "stepDetails", "destination", "primaryData", "item", 4, "ngIf"], [3, "disabledControls", "stepDetails", "destination", "primaryData", "item"], [1, "pb-3", "w-100", 2, "border-bottom", "1px dashed lightgray"], ["styleClass", "p-datatable-gridlines", "dataKey", "id", 1, "profile-table", "pa-table", "im-card-no-border-table", "im-card-table-noborder-spacing", "table", 3, "columns", "value", "onRowExpand"], [2, "width", "3rem"], [1, "expandIcon"], [1, "text-truncate"], ["type", "button", "pTooltip", "Delete", "pButton", "", "icon", "pi pi-trash", 1, "p-button-text", "p-button-rounded", "btnTrash", 3, "disabled", "click"], ["type", "button", "pTooltip", "Sync", "pButton", "", "icon", "pi pi-refresh", 1, "p-button-text", "p-button-rounded", "refreshIcon", 3, "disabled", "click"], ["colspan", "7"], ["class", "courseList pt-2", 4, "ngIf"], [1, "courseList", "pt-2"], [1, "col-md-12"], ["pButton", "", "type", "button", "icon", "pi pi-trash", 1, "p-button-text", "p-button-rounded", 3, "disabled", "click"], [1, "pl-3", "pb-3", "w-100", 2, "border-bottom", "1px dashed lightgray"], ["styleClass", "p-datatable-gridlines", "dataKey", "id", 1, "im-card-no-border-table", "im-card-table-noborder-spacing", "table", 3, "columns", "value", "onRowExpand"], ["type", "button", "pButton", "", "icon", "pi pi-trash", "pTooltip", "Delete", 1, "p-button-text", "p-button-rounded", "btnTrash", 3, "disabled", "click"], [3, "stepId", "taskId", "viewQuestions", "showSaveBtn", "loadedIn", "isSection", "isCustomTriggered"], [1, "pl-3", "pb-3"], ["class", "col-md-6", 4, "ngIf"], ["class", "col-md-6 completeStep", 4, "ngIf"], [1, "col-md-6"], ["pButton", "", "type", "button", "label", "Save", 3, "ngClass", "disabled", "click"], ["pButton", "", "type", "button", "label", "Close", 3, "ngClass", "disabled", "click"], [1, "col-md-6", "completeStep"], [1, "d-flex", "col-12", "justify-content-end", 3, "visaType", "stepDetails", "type", "showPreviousStepBtn", "showNextStepBtn"], ["class", "col-md-12 pt-3 customSave alignRight", 4, "ngIf"], ["class", "col-md-12 customSave alignRight", 4, "ngIf"], [1, "col-md-12", "pt-3", "customSave", "alignRight"], ["pButton", "", "type", "button", "label", "Save & Continue", 3, "ngClass", "disabled", "click"], [1, "col-md-12", "customSave", "alignRight"]], template: function EducationDetailsLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, EducationDetailsLibraryComponent_div_1_Template, 4, 3, "div", 1);
        i0.ɵɵtemplate(2, EducationDetailsLibraryComponent_div_2_Template, 3, 1, "div", 2);
        i0.ɵɵtemplate(3, EducationDetailsLibraryComponent_ng_container_3_Template, 2, 1, "ng-container", 3);
        i0.ɵɵelementStart(4, "div", 4);
        i0.ɵɵtemplate(5, EducationDetailsLibraryComponent_ng_container_5_Template, 2, 1, "ng-container", 3);
        i0.ɵɵtemplate(6, EducationDetailsLibraryComponent_div_6_Template, 11, 4, "div", 5);
        i0.ɵɵtemplate(7, EducationDetailsLibraryComponent_div_7_Template, 2, 4, "div", 6);
        i0.ɵɵtemplate(8, EducationDetailsLibraryComponent_ng_container_8_Template, 41, 13, "ng-container", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(9, EducationDetailsLibraryComponent_p_divider_9_Template, 1, 0, "p-divider", 3);
        i0.ɵɵtemplate(10, EducationDetailsLibraryComponent_div_10_Template, 4, 3, "div", 2);
        i0.ɵɵtemplate(11, EducationDetailsLibraryComponent_div_11_Template, 3, 2, "div", 2);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isSimplifyH1b ? false : true);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isSimplifyH1b ? false : true);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isWizard);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", ctx.isWizard ? "main-body-remove-scroll" : "main-body footer-adjust-v2");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isWizard);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isEducationView);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isEducationView && ctx.selectedState == "simple");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isEducationView);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isSimplifyH1b ? false : true);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isSimplifyH1b ? false : true);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isSimplifyH1b ? true : false);
    } }, directives: [i10.NgIf, i10.NgClass, i11.StepStatusUpdateComponentLibraryComponent, i12.MaximizeDialogLibraryComponent, i13.AssigningTaskLibraryComponent, i14.Divider, i15.LastUpdateLibraryComponent, i16.ButtonDirective, i17.Tooltip, i18.MatIcon, i19.GenericBeneficiaryEducationComponent, i20.EditorLibraryComponent, i21.Table, i22.PrimeTemplate, i10.NgForOf, i21.RowToggler, i23.Card, i24.SendBackComponentLibraryComponent, i25.NotificationComponentLibrary, i26.CustomQuestionnaireComponent], pipes: [i27.VisaDateFormatPipe], styles: [".courses-title[_ngcontent-%COMP%]{padding:0;border-bottom:1px solid #979797}.courses-title[_ngcontent-%COMP%]:last-child{border-bottom:none;padding:0}.redColor[_ngcontent-%COMP%]{color:#e80b18!important}.icons-arrow[_ngcontent-%COMP%]{cursor:pointer}.profile-title[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]{color:#0a7bb8;font-size:18px;margin-bottom:0}.btn-group[_ngcontent-%COMP%]{justify-content:right}.close-icon[_ngcontent-%COMP%]{color:#fff;background-color:#000;padding:8px;border-radius:20px;font-weight:700;cursor:pointer}.expandIcon[_ngcontent-%COMP%]{display:inline-flex;border-right:none!important}.expandIcon[_ngcontent-%COMP%]   .flag-text[_ngcontent-%COMP%]{color:#2c2c2c;font-size:14px;padding:5px 10px}.pa-table[_ngcontent-%COMP%]   .expandIcon[_ngcontent-%COMP%]{padding:10px 5px 5px!important}.pa-table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{vertical-align:bottom;padding:15px!important;font-style:normal;font-variant:normal;font-weight:700}.pa-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%], .pa-table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{color:#4a4a4a;font-size:13px}.pa-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{border-top:none!important;padding:15px 15px 0!important}.pa-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{padding:0 0 10px!important;color:#4a4a4a}.pa-table[_ngcontent-%COMP%]   .courseList[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]{font:normal normal 700 16px/22px Source Sans Pro;color:#626262}.pa-table[_ngcontent-%COMP%]   .courses-card[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]{font:normal normal normal 16px/22px Source Sans Pro;color:#333}.pa-table[_ngcontent-%COMP%]   .courses-card[_ngcontent-%COMP%]   .duty-list[_ngcontent-%COMP%]{font:normal normal normal 16px/24px Source Sans Pro;color:#626262}.step-title[_ngcontent-%COMP%]   h5[_ngcontent-%COMP%]{font:normal normal 700 22px/32px Source Sans Pro;color:#3d3d63}.step-title[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{font:normal normal normal 16px/22px Source Sans Pro;color:#626262}.rowHeader[_ngcontent-%COMP%]   h6[_ngcontent-%COMP%]{font:normal normal 600 20px/28px Source Sans Pro;color:#0a7bb8}.btnData[_ngcontent-%COMP%]{background:#fff 0 0 no-repeat padding-box!important;border:1px solid #19a0da!important;border-radius:5px!important;font:normal normal 700 14px/20px Source Sans Pro!important;color:#19a0da!important;text-transform:uppercase!important;padding:10px!important}.syncBtn[_ngcontent-%COMP%]{width:100px!important;font-size:14px!important;font-weight:700!important}.pi-trash[_ngcontent-%COMP%]:before{content:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAANCAYAAAB/9ZQ7AAAABHNCSVQICAgIfAhkiAAAATRJREFUKFOVkL9LglEUhp9zPwUtKsKxFgezPyBa25qCoP4A/aaGxqK1oK2lwaQpyqXBlmgNcixoqKFCRCNbWoNIxPy+07EfpBBYFy6Xe+7zvvc9R+hee+UhPHeIyICVV8mkrrqfhWJthEY4RxjGcbKCejkcTTRYMtEZyg3CvQnPhYPKiRVfCDWB0ygqT19uw3aO2q6DzoIrduBTQmLmet0T6fuijKMah3DLYjwkabRuEV37HZZFg+/w08ufmV+DOs6bRtubqNs14bxlvTTxmOU1Z6r4E7kfOKIztCng3Lo161usksVLGix/h60za7xCJr3T3/lfsIhnkyiTTef7O/fAJY1Qr14gbsEcEkj02X4eJNZq8iZCK9iw+jH+5JF8zHa/lsILtgmY6pm1xyOhFMim8p36O3w/o9UX027qAAAAAElFTkSuQmCC\")!important}.text-uppercase[_ngcontent-%COMP%]{font:normal normal 300 14px/20px Source Sans Pro!important;color:#4a4a4a!important;text-transform:capitalize!important}.tableData[_ngcontent-%COMP%]{color:#4a4a4a!important}.docFileName[_ngcontent-%COMP%], .tableData[_ngcontent-%COMP%]{font:normal normal normal 16px/22px Source Sans Pro!important}.docFileName[_ngcontent-%COMP%]{color:#0067b4!important}.document-header[_ngcontent-%COMP%]{background:#dbdbdb 0 0 no-repeat padding-box!important;border:1px solid #b5b5b5!important;border-radius:5px 5px 0 0!important}.courseName[_ngcontent-%COMP%]{font:normal normal normal 16px/24px Source Sans Pro!important;color:#626262!important}.tableHeader[_ngcontent-%COMP%]{background:#efefef 0 0 no-repeat padding-box!important}.eduTable[_ngcontent-%COMP%], .tableHeader[_ngcontent-%COMP%]{border:none!important}.pi-check[_ngcontent-%COMP%]:before{content:url(\"data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 width%3D%2223.5%22 height%3D%2217.66%22 viewBox%3D%220 0 23.5 17.66%22%3E  %3Cg id%3D%22Group_306%22 data-name%3D%22Group 306%22 transform%3D%22translate(-835.271 -201.546)%22%3E    %3Cg id%3D%22Group_301%22 data-name%3D%22Group 301%22%3E      %3Cg id%3D%22Group_300%22 data-name%3D%22Group 300%22%3E        %3Cg id%3D%22Group_299%22 data-name%3D%22Group 299%22%3E          %3Cg id%3D%22Group_298%22 data-name%3D%22Group 298%22%3E            %3Cpath id%3D%22Path_208%22 data-name%3D%22Path 208%22 d%3D%22M839.048%2C211.877a.75.75%2C0%2C0%2C1-.746-.684c-.027-.307-.04-.566-.04-.816a8.83%2C8.83%2C0%2C0%2C1%2C14.949-6.368.75.75%2C0%2C1%2C1-1.039%2C1.082%2C7.33%2C7.33%2C0%2C0%2C0-12.409%2C5.286c0%2C.2.011.422.034.684a.75.75%2C0%2C0%2C1-.681.813Z%22 fill%3D%22%2330b1e1%22%2F%3E          %3C%2Fg%3E        %3C%2Fg%3E      %3C%2Fg%3E      %3Cpath id%3D%22Path_209%22 data-name%3D%22Path 209%22 d%3D%22M838.8%2C212.45a.749.749%2C0%2C0%2C1-.6-.294l-2.776-3.622a.75.75%2C0%2C0%2C1%2C1.191-.912l2.321%2C3.028%2C3.038-2.315a.75.75%2C0%2C0%2C1%2C.909%2C1.193l-3.633%2C2.768A.747.747%2C0%2C0%2C1%2C838.8%2C212.45Z%22 fill%3D%22%2330b1e1%22%2F%3E    %3C%2Fg%3E    %3Cg id%3D%22Group_305%22 data-name%3D%22Group 305%22%3E      %3Cg id%3D%22Group_304%22 data-name%3D%22Group 304%22%3E        %3Cg id%3D%22Group_303%22 data-name%3D%22Group 303%22%3E          %3Cg id%3D%22Group_302%22 data-name%3D%22Group 302%22%3E            %3Cpath id%3D%22Path_210%22 data-name%3D%22Path 210%22 d%3D%22M846.948%2C219.206a8.787%2C8.787%2C0%2C0%2C1-6.116-2.463.75.75%2C0%2C1%2C1%2C1.039-1.082%2C7.33%2C7.33%2C0%2C0%2C0%2C12.409-5.286c0-.2-.011-.422-.034-.684a.75.75%2C0%2C0%2C1%2C1.494-.132c.027.307.04.567.04.816A8.842%2C8.842%2C0%2C0%2C1%2C846.948%2C219.206Z%22 fill%3D%22%2330b1e1%22%2F%3E          %3C%2Fg%3E        %3C%2Fg%3E      %3C%2Fg%3E      %3Cpath id%3D%22Path_211%22 data-name%3D%22Path 211%22 d%3D%22M858.022%2C213.424a.749.749%2C0%2C0%2C1-.6-.294l-2.32-3.028-3.038%2C2.315a.75.75%2C0%2C0%2C1-.909-1.193l3.633-2.768a.75.75%2C0%2C0%2C1%2C1.05.14l2.775%2C3.622a.75.75%2C0%2C0%2C1-.595%2C1.206Z%22 fill%3D%22%2330b1e1%22%2F%3E    %3C%2Fg%3E  %3C%2Fg%3E%3C%2Fsvg%3E\")!important}.updateEducation[_ngcontent-%COMP%]{position:absolute;display:flex;padding-left:200px;padding-bottom:20px}.customSave[_ngcontent-%COMP%]{display:flex;justify-content:flex-end}.main-body-remove-scroll[_ngcontent-%COMP%]{width:100%;overflow:auto}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EducationDetailsLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'education-details-library',
                templateUrl: './education-details-library.component.html',
                styleUrls: ['./education-details-library.component.scss']
            }]
    }], function () { return [{ type: i1.Store }, { type: i2.APIEducationDetails }, { type: i3.ToastrService }, { type: i4.StepStatusUpdatePayloadService }, { type: i5.DialogService }, { type: i6.Router }, { type: i7.AppServicesLibraryService }, { type: i8.DirtyFormGuard }, { type: i9.ReferenceLibraryService }]; }, { primaryData: [{
            type: Input
        }], simplifyH1b: [{
            type: Input
        }], isWizard: [{
            type: Input
        }], onDialogClose: [{
            type: Output
        }] }); })();

class EducationDetailsLibraryModule {
}
EducationDetailsLibraryModule.ɵfac = function EducationDetailsLibraryModule_Factory(t) { return new (t || EducationDetailsLibraryModule)(); };
EducationDetailsLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: EducationDetailsLibraryModule });
EducationDetailsLibraryModule.ɵinj = i0.ɵɵdefineInjector({ providers: [BaseEducationDetailsLibraryService], imports: [[
            PrimengLibraryModule,
            StepStatusUpdateComponentLibraryModule,
            DeleteDialogLibraryModule,
            SendBackComponentLibraryModule,
            NotificationComponentLibraryModule,
            DateFormatModule,
            EditorLibraryModule,
            LastUpdateLibraryModule,
            EditEducationDetailsTabModule,
            AssigningTaskLibraryModule,
            CustomQuestionnaireModule,
            MaximizeDialogLibraryModule,
            ImportProfileDetailsModule,
            MatButtonToggleModule,
            GenericBeneficiaryEducationModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(EducationDetailsLibraryModule, { declarations: [EducationDetailsLibraryComponent], imports: [PrimengLibraryModule,
        StepStatusUpdateComponentLibraryModule,
        DeleteDialogLibraryModule,
        SendBackComponentLibraryModule,
        NotificationComponentLibraryModule,
        DateFormatModule,
        EditorLibraryModule,
        LastUpdateLibraryModule,
        EditEducationDetailsTabModule,
        AssigningTaskLibraryModule,
        CustomQuestionnaireModule,
        MaximizeDialogLibraryModule,
        ImportProfileDetailsModule,
        MatButtonToggleModule,
        GenericBeneficiaryEducationModule], exports: [EducationDetailsLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(EducationDetailsLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [EducationDetailsLibraryComponent],
                imports: [
                    PrimengLibraryModule,
                    StepStatusUpdateComponentLibraryModule,
                    DeleteDialogLibraryModule,
                    SendBackComponentLibraryModule,
                    NotificationComponentLibraryModule,
                    DateFormatModule,
                    EditorLibraryModule,
                    LastUpdateLibraryModule,
                    EditEducationDetailsTabModule,
                    AssigningTaskLibraryModule,
                    CustomQuestionnaireModule,
                    MaximizeDialogLibraryModule,
                    ImportProfileDetailsModule,
                    MatButtonToggleModule,
                    GenericBeneficiaryEducationModule
                ],
                providers: [BaseEducationDetailsLibraryService],
                exports: [EducationDetailsLibraryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of education-details-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { EducationDetailsLibraryComponent, EducationDetailsLibraryModule, EducationDetailsLibraryService };
//# sourceMappingURL=education-details-library.js.map
